import React from 'react';
import { Typography, useTheme, useMediaQuery } from '@mui/material';
import { StyledTableCell } from './OptionTableCell';

const StrikeCell = ({ 
  strikePrice, 
  spotPrice, 
  isAtmRow 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <StyledTableCell 
      className="strike-cell" 
      header="strike"
      sx={{
        color: theme.palette.mode === 'dark' ? theme.palette.text.primary : '#333333',
        fontWeight: isAtmRow ? 700 : 500,
        fontSize: isAtmRow ? '0.95rem' : '0.9rem',
        borderLeft: `1px solid ${theme.palette.divider}`,
        borderRight: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
        padding: isMobile ? '4px 2px' : '6px 2px',
        textAlign: 'center',
        width: '90px',
        minWidth: '90px',
        maxWidth: '90px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      {strikePrice}
    </StyledTableCell>
  );
};

export default StrikeCell; 